/*@ngInject*/
const FormViewerController = function ($window, $rootScope, $scope, $stateParams, $state, $timeout, localization, fieldType,
                                       formMediator, formTemplateType, formViewerConstant,
                                       formViewerUtil, submissionConstant, formatUtil, coreMediator) {

    $scope.timeoutList = [];
    $scope.fieldType = fieldType;

    localization.getTranslations().then(function (translations) {
        $scope.printFormTooltip = _.get(translations, 'formsViewer.printFormTooltip');
    });

    var loadForm = function () {
        $scope.isLoading = true;
        $scope.sectionList = [];
        $scope.effectiveDate = $scope.effectiveDate || moment.now();

        if ($scope.isConfigurableForm) {
            formMediator.loadStaticForm($scope.formId);
        }
        else {
            formMediator.loadRootForm($scope.formId, $scope.printPreview, $scope.effectiveDate, $scope.currencyCode);
        }

        $scope.timeoutList.push($timeout(function () {
            $rootScope.$broadcast(formViewerConstant.event.FORM_LAZY_RENDERING_START, $scope.formId);
        }, 1));
    };

    if ($scope.supplemental) {
        $scope.sectionList = $scope.formData.sectionList;
    }

    $scope.showNextRequiredField = function () {
        $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD, $scope.formId);
    };

    $scope.$on(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD_AFTER_FORM_LOAD, function () {
        formMediator.setDelayShowNextRequiredField(true);
    });

    $scope.printForm = function () {
        $rootScope.$broadcast(submissionConstant.event.CLOSE_CHECKLIST);
        $rootScope.$broadcast(submissionConstant.event.CLOSE_COLLABORATION);
        $rootScope.$broadcast(submissionConstant.event.CLOSE_ACTIVITY_STREAM);
        $rootScope.$broadcast(submissionConstant.event.CLOSE_SNIPPETS);

        $window.print();
    };

    $scope.showPrintIcon = function () {
        let isPrintable = _.isUndefined($scope.printable) ? true : $scope.printable;
        let isPrintPreview = _.isUndefined($scope.formData) || _.isUndefined($scope.formData.formModel) ? false : $scope.formData.formModel.printPreview;

        return isPrintable && !isPrintPreview;
    };

    if (!$scope.supplemental) {
        $scope.shouldProcessFormEvent = function (fieldModel) {
            let rootFormId = parseInt($scope.formId);
            return !$scope.isLoading && formMediator.shouldProcessForm(rootFormId, fieldModel.formId);
        };

        $scope.$on(formViewerConstant.event.CREATE_FIELD_MESSAGE, function (event, fieldModel) {
            if ($scope.shouldProcessFormEvent(fieldModel)) {
                formMediator.processFieldUpdate(fieldModel, $scope.formId);
            }
        });

        $scope.$on(formViewerConstant.event.UPDATE_FIELD_MESSAGE, function (event, fieldModel) {
            if ($scope.shouldProcessFormEvent(fieldModel)) {
                formMediator.processFieldUpdate(fieldModel, $scope.formId);
            }
        });

        $scope.$on(formViewerConstant.event.DELETE_FIELD_MESSAGE, function (event, fieldModel) {
            if ($scope.shouldProcessFormEvent(fieldModel)) {
                formMediator.processFieldDelete(fieldModel, $scope.formId);
            }
        });

        $scope.$on(formViewerConstant.event.RENAME_FIELD_MESSAGE, function (event, fieldModel) {
            if ($scope.shouldProcessFormEvent(fieldModel)) {
                formMediator.processFieldRename(fieldModel, $scope.formId);
            }
        });

        $scope.$on(formViewerConstant.event.FORM_STRUCTURE_CHANGED, function (event, rootFormId) {

            if ($scope.formId === rootFormId) {
                $scope.formData = formMediator.getFormStructure($scope.formId);
                if(!_.isEmpty($scope.formData)) {
                    $rootScope.$broadcast(formViewerConstant.event.FORM_DATA_READY, $scope.formData, rootFormId);

                    if (formMediator.isDelayShowNextRequiredField()) {
                        formMediator.resetDelayShowNextRequiredField();
                        $scope.$on(formViewerConstant.event.FORM_LAZY_RENDERING_END, function (event) {
                            $scope.timeoutList.push($timeout(function () {
                                $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD, $scope.formId);
                            }, 500));
                        });
                    }
                }
            }
        });

        $scope.$on(formViewerConstant.event.CREATE_NEW_SUPPLEMENTAL_FORM, function (event, form) {
            let currentRootFormId = parseInt($scope.formId),
                eventRootFormId = form.rootFormId ? form.rootFormId : form.id;

            if (currentRootFormId === eventRootFormId) {
                if ($scope.isLoading) {
                    return;
                }
                formMediator.createSupplementalForm(form, $scope.formId, $scope.printPreview);
                $scope.timeoutList.push($timeout(function () {}, 0));
            }
        });

        $scope.$on(formViewerConstant.event.DELETE_SUPPLEMENTAL_FORM, function (event, form) {
            let currentRootFormId = parseInt($scope.formId),
                eventRootFormId = form.rootFormId ? form.rootFormId : form.id;

            function attemptSupplementalFormDelete(supplementalForm, rootFormId, attemptCount) {
                const maxTries = 10;
                const shouldRetry = attemptCount < maxTries;
                const isDeleteSuccessful = formMediator.deleteSupplementalForm(supplementalForm, rootFormId);

                if(!isDeleteSuccessful && shouldRetry) {
                    $timeout(() => {
                        attemptSupplementalFormDelete(supplementalForm, rootFormId, attemptCount + 1);
                    }, 500);
                }
            }

            if (currentRootFormId === eventRootFormId) {
                if ($scope.isLoading) {
                    return;
                }

                attemptSupplementalFormDelete(form, $scope.formId, 0);
            }
        });

        $scope.$on(formViewerConstant.event.UPDATE_ROOT_FORM, function (event, form) {
            let currentRootFormId = parseInt($scope.formId),
                eventRootFormId = form.rootFormId ? form.rootFormId : form.id;

            if (currentRootFormId === eventRootFormId) {
                if ($scope.isLoading) {
                    return;
                }
                formMediator.processRootFormUpdate(form, $scope.formId);
            }
        });

        $scope.$on(formViewerConstant.event.DELETE_ROW, function (event, message) {
            let rootFormId = parseInt($scope.formId),
                shouldProcessRowEvent = formMediator.shouldProcessForm(rootFormId, message.messagePayload.formId);

            if (shouldProcessRowEvent) {
                formMediator.processRemoteRowDeletion(message, $scope.formId);
            }
        });

        $scope.$on(formViewerConstant.event.CREATE_ROW, function (event, message) {
            let rootFormId = parseInt($scope.formId),
                shouldProcessRowEvent = formMediator.shouldProcessForm(rootFormId, message.messagePayload.formId);

            if (shouldProcessRowEvent) {
                formMediator.processRemoteRowAddition(message, $scope.formId);
            }
        });

        $scope.$on(formViewerConstant.event.UPDATE_ROW, function (event, message) {
            let rootFormId = parseInt($scope.formId),
                shouldProcessRowEvent = formMediator.shouldProcessForm(rootFormId, message.formId);

            if (shouldProcessRowEvent) {
                formMediator.processRemoteRowUpdate(message, $scope.formId);
            }
        });

        $scope.$on(formViewerConstant.event.RELOAD_FORM, function () {
            loadForm();
        });

        $scope.$on('$destroy', function () {
            let hasLoginToken = !_.isNil(coreMediator.getLoginToken());

            if (hasLoginToken) {
                formMediator.unregisterForm($scope.formId);
            }

            _.each($scope.timeoutList, function (item) {
                if (item) {
                    $timeout.cancel(item);
                }
            });
        });

        $scope.$watch('formId', function (newFormId, oldFormId) {
            if (newFormId) {
                loadForm();

                if (oldFormId && oldFormId !== newFormId) {
                    formMediator.unregisterForm(oldFormId);
                }
            }
        });
    }
};

angular.module('umFormViewer')
    .controller('formViewerController', FormViewerController);
